import { Box, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Card from "./Card";
import { getExperincesData } from "../../Services/firebase";
import SectionTitle from "../Common/SectionTitle";
import Loader from "../Loader";
const Experience = () => {
  const [experinces, setExperinces] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchExperincesData = async () => {
    setLoading(true);
    const results = getExperincesData();
    results
      .then((res) => {
        const data = res.sort((e1, e2) => e1.order - e2.order);
        setExperinces(data);
        setLoading(false);
      })
      .catch((err) => {
        setExperinces([]);
        setLoading(false);
        console.log("error:", err);
      });
  };

  useEffect(() => {
    fetchExperincesData();
  }, []);
  return (
    <Box>
      {/* title */}
      <SectionTitle title="Professional Journey" />
      <Box maxW="1280px" mx="auto" w="full">
        {loading ? (
          <Loader />
        ) : (
          experinces.map((exp, idx) => {
            return (
              <Card
                key={exp.id}
                companyTitle={exp.title}
                companyDesc={exp.desc}
                start_date={exp.start_date}
                end_date={exp.end_date}
                role={exp.role}
                direction={idx % 2 === 0 ? "forward" : "backward"}
              />
            );
          })
        )}
      </Box>
    </Box>
  );
};

export default Experience;
